import BillingReportForm from '@/forms/BillingReportForm';
import Container from '@/ui/components/Container';

const NewBillingReport = () => {
  return (
    <Container type="page">
      <BillingReportForm />
    </Container>
  );
};

export default NewBillingReport;
